import Dropdown from 'app/components/Dropdown';
import AltTag from 'app/constants/alt-tag';
import { APP_CONSTANTS, LocalSessionKey } from 'app/constants/app-constants';
import { LocalStorage, SessionStorage } from 'app/utils/storage';
import Group from 'assets/images/Group.svg';
import Open from 'assets/images/ic-chevron-down.png';
import AddUser from 'assets/images/ic-users-add.svg';
import LogoutImage from 'assets/images/logout.png';
import AppLogoImage from 'assets/images/pacificlogo.svg';
import { useEffect, useMemo, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import './index.scss';

const Header = ({ mallList, selectedMallIds, handleChange }) => {
  const [malltemp, setMallTemp] = useState([]);

  useEffect(() => {
    setMallTemp(mallList);
  }, [mallList]);

  const [isLogoutVisible, setIsLogoutVisible] = useState(false);

  useEffect(() => {
    const customerData = JSON.parse(
      LocalStorage.get(LocalSessionKey.CUSTOMER_DATA)
    );
    const pathname = window.location.pathname;
    const urlParts = pathname.split('/');
    const customersIndex = urlParts.indexOf('customers');
    const urlCustomerId =
      customersIndex !== -1 && urlParts.length > customersIndex + 2
        ? urlParts[customersIndex + 2]
        : null;
    if (
      pathname.startsWith('/customers/') &&
      customerData &&
      customerData?.id &&
      urlCustomerId &&
      customerData?.id !== parseInt(urlCustomerId)
    ) {
      window.location.href = '/customers';
    }
  }, []);

  const toggleLogoutVisibility = () => {
    setIsLogoutVisible(!isLogoutVisible);
  };

  const handleLogOut = async () => {
    confirmAlert({
      title: '',
      message: 'Are you sure you want to sign out?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            sureLogout();
          },
        },
        {
          label: 'No',
        },
      ],
    });
  };

  async function sureLogout() {
    await LocalStorage.clear();
    await SessionStorage.clear();
    window.location.href = APP_CONSTANTS.LOGIN;
    return;
  }
  async function profile() {
    window.location.href = APP_CONSTANTS.Profile;
    return;
  }
  const [user, setUser] = useState({});
  async function isUserInfo() {
    const user = await LocalStorage.get(LocalSessionKey.USER_INFO);
    const val = JSON.parse(user);

    setUser({ ...val });
  }

  useEffect(() => {
    isUserInfo();
  }, []);
  function getUserInitials(name) {
    const nameParts = name.split(' ');
    if (nameParts.length > 1) {
      return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  }

  const userInitials = useMemo(() => {
    if (user && user.name) {
      return getUserInitials(user.name);
    }
    return '';
  }, [user?.name]);

  return (
    <div className='header'>
      <div className='header__left'>
        <img className='header__logo' alt={AltTag.AppLogo} src={AppLogoImage} />
        <img className='header__head_image' alt={AltTag.AppLogo} src={Group} />
      </div>{' '}
      <div className='wd-50 mt-3'>
        <Dropdown
          id={'mallId'}
          name='mallId'
          options={malltemp}
          placeholder='Select Mall'
          value={selectedMallIds}
          handleChange={handleChange}
        />
      </div>
      <div className='header__right'>
        <div className='header__profile' onClick={toggleLogoutVisibility}>
          <>
            <span className='header__profile-name'>
              <span className='header__profile-name__initials'>
                {userInitials}
              </span>
              {user?.name}
              <img src={Open} alt='open' />
            </span>
            {isLogoutVisible && (
              <span className='header__logout'>
                <>
                  <div onClick={handleLogOut} className='mt-2'>
                    <img src={LogoutImage} alt='Logout' />
                    <span className='signout'>Sign Out</span>
                  </div>
                </>
                <>
                  <div onClick={profile} className='mt-2'>
                    <img src={AddUser} alt='add-user' />
                    <span className='signout'>Profile</span>
                  </div>
                </>
              </span>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default Header;
